/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Preset_30dInputs */

const vi_report_preset_30d = /** @type {(inputs: Report_Preset_30dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 ngày`)
};

/**

* @param {Report_Preset_30dInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_preset_30d = /** @type {((inputs?: Report_Preset_30dInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Preset_30dInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_preset_30d(inputs)
});